import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createExportJob } from "@/features/exports/api/create";
import { exportKeys } from "@/lib/query/keys";
import type { CreateExportJobFromSelectionRequest } from "@/types/api";

export function useCreateExport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateExportJobFromSelectionRequest) => createExportJob(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: exportKeys.all });
    },
  });
}
